import Template from "backbone/shared/templates/password_requirements.js.hamlc"

export default class PasswordRequirementsView extends Backbone.View
  events:
    "keyup #user_email" : "updatePasswordRequirementsStatus"
    "keyup #user_password" : "updatePasswordRequirementsStatus"

  initialize: (options) ->
    @specialCharacters = options.specialCharactersString.split("")
    @consecutiveCharSet = @buildConsecutiveCharSet()
    @emailField = @$el.find("#user_email")
    @usernameField = @$el.find("#user_username")
    @passwordField = @$el.find("#user_password")
    @requirementDiv = @$el.find(".js-password-requirements")
    @renderRequirements()

  buildConsecutiveCharSet: ->
    chars = 'abcdefghijklmnopqrstuvwxyz'
    nums = '1234567890'

    states = [
      [ 'toLowerCase','toLowerCase','toLowerCase' ]
      [ 'toLowerCase','toLowerCase','toUpperCase' ]
      [ 'toLowerCase','toUpperCase','toLowerCase' ]
      [ 'toLowerCase','toUpperCase','toUpperCase' ]
      [ 'toUpperCase','toLowerCase','toLowerCase' ]
      [ 'toUpperCase','toLowerCase','toUpperCase' ]
      [ 'toUpperCase','toUpperCase','toLowerCase' ]
      [ 'toUpperCase','toUpperCase','toUpperCase' ]
    ]
    charSet = []

    i = 0
    while i < chars.length - 2
      substr = chars.slice(i, i + 3)
      j = 0
      while j < states.length
        combo = ''
        k = 0
        while k < 3
          combo += substr[k][states[j][k]]()
          k++
        charSet.push(combo)
        j++
      i++

    i = 0
    while i < nums.length - 2
      charSet.push(nums.slice(i, i + 3))
      i++

    return charSet

  updatePasswordRequirementsStatus: ->
    @renderRequirements()
    @renderPasswordField()

  hasMoreThan8Characters: ->
    @passwordField.val().length >= 8

  hasOneDigitAndOneLetter: ->
    /\d/.test(@passwordField.val()) && /[a-z]/i.test(@passwordField.val())

  hasOneSpecialCaracter: ->
    for specialCharacter in @specialCharacters
      return true if @passwordField.val().indexOf(specialCharacter) >= 0
    false

  usernameFromEmail: ->
    if @emailField.val() && @emailField.val().indexOf('@') > 0
      @emailField.val().split('@')[0]

  usernameCheckInfo: ->
    if @usernameField.val()
      return "Does not contain your username, " + @usernameField()
    else if @usernameFromEmail()
      return "Does not contain your username, " + @usernameFromEmail()
    else
      return "Does not contain your username"

  doesNotContainUsername: ->
    if @passwordField.val() && @usernameFromEmail()
      if @passwordField.val().toLowerCase().indexOf(@usernameFromEmail()) >= 0
        return false
    return true

  hasMixOfUpperAndLower: ->
    /[a-z]/.test(@passwordField.val()) && /[A-Z]/.test(@passwordField.val())

  doesNotHaveIdenticalCharacters: ->
    !/([a-zA-Z0-9])\1\1/.test(@passwordField.val())

  hasConsecutiveCharacters: ->
    if @findConsecutiveCharacters(@passwordField.val())
      return true
    else
      return false

  findConsecutiveCharacters: (string) ->
    match = null
    i = 0
    while !match && i < @consecutiveCharSet.length
      set = @consecutiveCharSet[i]
      if string.indexOf(set) >= 0
        match = set
      i++
    return match

  isEmpty: ->
    @passwordField.val().length == 0

  renderStatusStyle: (fieldStatus) ->
    if @isEmpty()
      return "empty"
    else if fieldStatus
      return "success"
    else
      return "error"

  renderPasswordField: ->
    if @isEmpty() || (@hasMoreThan8Characters() && @hasOneDigitAndOneLetter() && @hasOneSpecialCaracter())
      @$el.find(".inline-checkbox-wrapper").removeClass("error")
    else
      @$el.find(".inline-checkbox-wrapper").addClass("error")

  renderRequirements: ->
    @requirementDiv.empty().append Template(
      passwordField: @passwordField.val(),
      specialCharacters: @specialCharacters,
      hasMoreThan8Characters: @renderStatusStyle(@hasMoreThan8Characters()),
      hasOneDigitAndOneLetter: @renderStatusStyle(@hasOneDigitAndOneLetter()),
      hasOneSpecialCaracter: @renderStatusStyle(@hasOneSpecialCaracter()),
      doesNotContainUsername: @renderStatusStyle(@doesNotContainUsername()),
      usernameCheckInfo: @usernameCheckInfo(),
      hasMixOfUpperAndLower: @renderStatusStyle(@hasMixOfUpperAndLower()),
      doesNotHaveIdenticalCharacters: @renderStatusStyle(@doesNotHaveIdenticalCharacters()),
      doesNotHaveConsecutiveCharacters: @renderStatusStyle(!@hasConsecutiveCharacters())
    )
    this



// WEBPACK FOOTER //
// ./app/javascript/backbone/shared/views/password_requirements_view.js.coffee